<template>
  <mdb-row center class="py-5">
    <mdb-col col-="12" class="text-center">
      <h2 class="YearTitle pentagon-gold">{{ year.year }}</h2>
    </mdb-col>

    <mdb-col
      col="12"
      v-for="member in year.members"
      class="text-center"
    >
      <Lid :member="member"/>
    </mdb-col>
  </mdb-row>
</template>

<script>
  import { mdbRow, mdbCol } from 'mdbvue';
  import Lid from './Lid';
  export default {
    name: 'Jaar',
    props: {
      year: {
        type: Object,
        required: true
      }
    },
    components: {
      Lid,
      mdbRow,
      mdbCol
    }
  };
</script>

<style scoped>
  .YearTitle {
    font-weight: bold;
  }
</style>
